import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { completeOAuth } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // useRef guard (not state) — set synchronously so StrictMode double-run can't double-exchange
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    const exchange = async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        completeOAuth(data);
        toast.success(`Welcome to the Lab, ${data.name}.`);
        navigate("/plans", { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    };
    exchange();
  }, [completeOAuth, navigate]);

  return (
    <main data-testid="auth-callback" className="pt-16 min-h-screen flex items-center justify-center bg-court-void">
      <p className="font-mono text-xs uppercase tracking-widest text-zinc-500">Signing you in…</p>
    </main>
  );
}
